import { render } from "./PagerComponent.vue?vue&type=template&id=10971034"
import script from "./PagerComponent.vue?vue&type=script&lang=js"
export * from "./PagerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__